import config from '../../config';
import NO_SHOW_UI_SCHEMA from '../../reports/noShowUISchema';
export default class LaborUISchema {
  constructor(Authentication, IntegrationService, SlingApi, Utils) {
    'ngInject';

    Object.assign(this, { Authentication, SlingApi, IntegrationService, Utils });
  }

  async getSchema() {
    if (!this.Authentication.user.org.isPremium) {
      return;
    }

    if (!this._getSchemaPromise) {
      const version =
        (this.Authentication.isSlingOrg() && config.LABOR_UI_SCHEMA_VERSION_FOR_SLING_ORG) ||
        config.LABOR_UI_SCHEMA_VERSION;
      this._getSchemaPromise = this.SlingApi.getLaborSchema({ version });
    }

    try {
      this.schema = await this._getSchemaPromise;
      this.schema.noShowReportUISchema = NO_SHOW_UI_SCHEMA;

      return this.schema;
    } catch {
      delete this._getSchemaPromise;
    }
  }

  clearCache() {
    delete this._getSchemaPromise;
  }

  evalIf(item, options = {}, settings = {}) {
    if (!item) {
      return false;
    }

    if (!('if' in item)) {
      return true;
    }

    return this.Utils.evaluateExpression(item.if, {
      options,
      settings,
      orgSettings: this.Authentication.user.orgSettings,
      enabledIntegrations: this.IntegrationService.enabledIntegrations,
    });
  }

  evalColor(item, summary = {}, options = {}) {
    if (!item || !('color' in item)) {
      return {};
    }

    return Object.entries(item.color).reduce((agg, [key, exp]) => {
      agg[key] = this.Utils.evaluateExpression(exp, {
        summary,
        options,
        orgSettings: this.Authentication.user.orgSettings,
      });
      return agg;
    }, {});
  }
}
